<script setup lang="ts">
import SSFooterAppStatus from './components/SSFooterAppStatus.vue'
import SSFooterPrinterDamagedStatus from './components/SSFooterPrinterDamagedStatus.vue'
import SSFooterClock from './components/SSFooterClock.vue'
import SSFooterActions from './components/SSFooterActions.vue'
import SSFooterDeviceInfo from './components/SSFooterDeviceInfo.vue'
</script>

<template>
  <footer class="ss-footer ss-w-100 ss-flex-center">
    <div class="ss-flex-center ss-gap-2xs">
      <SSFooterAppStatus />
      <SSFooterPrinterDamagedStatus />
      <SSFooterClock />
      <SSFooterActions />
    </div>
    <SSFooterDeviceInfo />
  </footer>
</template>

<style lang="scss" scoped>
.ss-footer {
  grid-area: footer;
  height: var(--ss-footer-height);
  background-color: var(--nxgds-mapped-color-surface-neutral-600);
  border-radius: var(--nxgds-alias-radius-corner-sm);
  padding: var(--nxgds-alias-spacing-xs);
}
</style>
